import jwtDecode from "jwt-decode"
import { useEffect, useState } from "react"
import { useMemo } from "react"
import { useSelector } from "react-redux"
import { getSubscriptionPath, getUserAccess } from "../helpers/utility"


const useUserPermission = (module) => {
    const { token } = useSelector(state => state?.auth)
    const [isAllow, setIsAllow] = useState(false)
    const userAccess = useMemo(() => {
        if (token) {
            return jwtDecode(token)?.userPrivileges
        }
    }, [token])
    useEffect(() => {
        if (userAccess) {
            const permission = userAccess?.[getUserAccess(module)]
            setIsAllow(permission)
        }
    }, [userAccess, module])

    return isAllow
}

export default useUserPermission